<ion-app>
  <ion-router-outlet [swipeGesture]="false"
                     class="{{
                     !isClockModalOpen &&
                     urlParameters &&
                     !noClockInPages.includes(urlParameters[urlParameters.length - 1]) &&
                     global.data.clock.status !== 'stopped' &&
                     global.data.clock.startDate ?
                     'show-clock': 'hide-clock'}}"></ion-router-outlet>
  @if (!isClockModalOpen &&
  urlParameters &&
  !noClockInPages.includes(urlParameters[urlParameters.length - 1]) &&
  global.data.clock.status !== 'stopped' &&
  global.data.clock.startDate) {
  <ion-footer
    class="clock-footer {{isSkipButtonActive ? 'show-skip' : ''}}"
      >
      <ion-toolbar (click)="onClockClick()">
        <ion-label>
  {{global.data.clock.startDate | date: "EEE dd MMM" : 'US/Pacific'}}
  @if (global.data.clock.status === 'started') {
  <ion-icon name="timer"></ion-icon>
  }
  @if (global.data.clock.status === 'lunch') {
  <ion-icon name="pause-circle"></ion-icon>
  }
  {{clockTime}}
  </ion-label>
</ion-toolbar>
</ion-footer>
  }
</ion-app>

<ion-modal #clockModal class="clock-modal {{isSkipButtonActive ? 'show-skip' : ''}}" [isOpen]="isClockModalOpen"
           (willDismiss)="onWillDismiss()"
           [canDismiss]="canDismiss()"
           [initialBreakpoint]="0.25"
           [breakpoints]="[0, 0.25]"
           handle="false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>
          {{global.data.clock.startDate | date: "EEE dd MMM" : 'US/Pacific'}}
          @if (global.data.clock.status === 'started') {
          <ion-icon name="timer"></ion-icon>
          }
          @if (global.data.clock.status === 'lunch') {
          <ion-icon name="pause-circle"></ion-icon>
          }
          {{clockTime}}
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        @if (global.data.clock.status === 'started') {
        <ion-item
          lines="none"
          (click)="isNotificationAlertOpen = true"
          [disabled]="isSkipButtonActive || global.data.isLoading">
          <ion-icon name="stop"></ion-icon>
          <ion-label>Stop Timer and Clock Out</ion-label>
        </ion-item>
        }
        @if (global.data.clock.status === 'lunch' || global.data.clock.status === 'stopped') {
        <ion-item
          lines="none"
          (click)="start()"
          [disabled]="isSkipButtonActive || global.data.clock.status === 'lunch' || global.data.isLoading">
          <ion-icon name="play"></ion-icon>
          <ion-label>Start Timer and Clock In</ion-label>
        </ion-item>
        }
        @if (global.data.clock.status === 'started' || global.data.clock.status === 'stopped') {
        <ion-item
          lines="none"
          (click)="pause()"
          [disabled]="global.data.isLoading">
          <ion-icon name="fast-food"></ion-icon>
          <ion-label>Take Lunch Break</ion-label>
        </ion-item>
        }
        @if (global.data.clock.status === 'lunch') {
        <ion-item
          lines="none"
          (click)="stop()"
          [disabled]="global.data.isLoading">
          <ion-icon name="fast-food"></ion-icon>
          <ion-label>Finish Lunch Break</ion-label>
        </ion-item>
        }
        @if (isSkipButtonActive) {
        <ion-item
          lines="none"
          (click)="skip()"
          [disabled]="global.data.isLoading">
          <ion-icon name="play-skip-forward-outline"></ion-icon>
          <ion-label>Skip</ion-label>
        </ion-item>
        }
      </ion-list>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-alert
  [isOpen]="isNotificationAlertOpen"
  header="Attention"
  message="This action will Clock Out the timer. Timer data will be sent to QuickBase"
  [buttons]="notificationAlertButtons"
  (didDismiss)="isNotificationAlertOpen = false"
  class="alert alert-warning"
></ion-alert>

<ion-alert
  [isOpen]="isSyncErrorAlertOpen"
  trigger="present-alert"
  header="Sync Error"
  message="It seems the internet connection is unstable. Please try again later."
  [buttons]="['OK']"
  (didDismiss)="isSyncErrorAlertOpen = false"
></ion-alert>
